// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__Pua0N","Icon":"Languages_Icon__3it3N","LanguagesSelect":"Languages_LanguagesSelect__h9jfx","minimalist":"Languages_minimalist__27THP"};